module.exports = __webpack_public_path__ + "img/pixel.4f1da725.svg";